// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4371":"d1a727b0","6257":"41df58d2","9265":"d1a727b0"}[chunkId] + ".chunk.css";
};